import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../../core/auth/services/config.service';
import { ScoreHistoryResponse, TimePeriodFilter } from '../assesment-const/assessment-details-models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssesmentdetailsService {

   private httpClient = inject(HttpClient);
    private configService = inject(ConfigService);
    private baseUrl = this.configService.getPatientAPIUrl();
    private apiUrl = this.configService.getAPIUrl(); // v2


  constructor() { }

  getScoreHistory(patientId: string, filter?: TimePeriodFilter): Observable<ScoreHistoryResponse> {
    let url = `${this.apiUrl}/api/Patient/scoreHistory?Patient_id=${patientId}`;
    if (filter) {
      url += `&Filter=${filter}`;
    }
    return this.httpClient.get<ScoreHistoryResponse>(url);
  }
}
